module.exports = __webpack_public_path__ + "media/images/icon_a6-cbd46b4e51fb8f5e412844e7c9237f29.png";